var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

require('jquery-validation');
require('./validate-custom-methods');

var validateHelpers = require('./validate-helpers');

// Define jQuery Selectors
var FORM_FIELD              = '.form__field';               // Field container

// Define Classes
var INPUT_VALID             = 'form__field--valid';         // Input is valid
var INPUT_INVALID           = 'form__field--invalid';       // Input is invalid
var FORM_FIELD_CONTAINER    = '.form__field-wrapper';       // Container holding form field

// Credit Card validation
var FIELD_CREDIT_CARD       = 'input__field--creditCard';   // Class for Credit Card inputs


// Run Validation
$.validator.setDefaults({
    // Enable debug mode to debug (WARNING: if it's set to true, you CANNOT submit forms!)
    debug: true,

    // This class is added to an element after it was validated and considered valid.
    validClass: INPUT_VALID,

    // Use this class to create error labels, to look for existing error labels and to add it to invalid elements.
    errorClass: INPUT_INVALID,

    // Rules for form validation
    // rules: rules,

    // Messages for form validation
    // messages: messages,

    // How to highlight invalid fields. Override to decide which fields and how to highlight.
    highlight: function(element, errorClass, validClass) {
        // Add 'invalid' class
        $(element).closest(FORM_FIELD).removeClass(validClass).addClass(errorClass);

        // Highlight credit card type (if relevant)
        if ($(element).hasClass(FIELD_CREDIT_CARD)) {
            validateHelpers.highlightCreditCardType(element);
        }
    },

    // Called to revert changes made by option highlight, same arguments as highlight.
    unhighlight: function(element, errorClass, validClass) {
        // Add 'valid' class
        $(element).closest(FORM_FIELD).removeClass(errorClass).addClass(validClass);

        // Highlight credit card type (if relevant)
        if ($(element).hasClass(FIELD_CREDIT_CARD)) validateHelpers.highlightCreditCardType(element);
    },

    // Place the error message
    errorPlacement: function (error, element) {
        if ($(element).is(':checkbox') || $(element).is(':radio')) {
            error.prependTo(element.closest(FORM_FIELD_CONTAINER));
        }
        else {
            error.appendTo(element.closest(FORM_FIELD_CONTAINER));
        }
    },

    // Validate function on focus out
    // - By default tabbing through fields won't run validation unless it was previously marked as invalid
    // - We want to validate as they tab through fields (i.e. immediate feedback when 'skipping fields')
    onfocusout: function(element) {
        $(element).valid();
    }

});


module.exports = function() {
};
